'use client'

import React from 'react'
import { cn } from '../../../lib/utils'
import Icon from '../Icon'
import { iconTypes } from '../Icon'

export type WorkflowChipStatus =
  | 'queued'
  | 'running'
  | 'completed'
  | 'failed'
  | 'canceled'

export type WorkflowChipProps = {
  runId: string
  workflowId: string
  workflowName: string
  status: WorkflowChipStatus
  updatedAt: string
  className?: string
  onClick?: () => void
}

const WorkflowChip: React.FC<WorkflowChipProps> = (props) => {
  const { workflowName, status, className, onClick } = props

  // Colors per status
  const variantClass =
    status === 'completed'
      ? 'text-green-600 border-green-600'
      : status === 'failed'
        ? 'text-red-600 border-red-600'
        : status === 'running'
          ? 'text-blue-600 border-blue-600'
          : 'text-foreground/70 border-foreground/30'

  // Icon per status
  const iconName: iconTypes =
    status === 'completed'
      ? 'Check'
      : status === 'running'
        ? 'LoaderCircle'
        : status === 'failed'
          ? 'CircleX'
          : 'Timer'

  return (
    <span
      className={cn(
        'border rounded-lg px-2 h-6 text-xs inline-flex items-center gap-1 max-w-40 truncate hover:opacity-90 cursor-pointer hover:bg-muted',
        variantClass,
        className,
      )}
      onClick={onClick}
    >
      <Icon
        name={iconName as iconTypes}
        size={12}
        className={cn(status === 'running' ? 'animate-spin' : '')}
      />
      <span className="truncate text-2xs max-w-16" title={workflowName}>
        {workflowName}
      </span>
    </span>
  )
}

export default WorkflowChip
